import React from "react";
import {
  assetHealthScore,
  incidentMetaDataFirst,
  preventiveMetaDataFirst,
  preventiveMetaDataSecond,
  renderItemsWithLabelClass,
  tpvMetaDataFirst,
  tpvMetaDataSecond,
  tpvMetaDataThird,
  workRequestMetaData,
  workRequestMetaDataFirst,
} from "./constant/maintenanceConstantData";
import { Divider } from "antd";

export const AssetHealthComponent = ({
  assetScore,
  preventiveMaintenanceScore,
  tpvScore,
  incidentScore,
  maintenanceWorkRequestScore,
  showcardClassName,
  childClassName,
}) => {
  return (
    <div className={showcardClassName}>
      <div className={childClassName}>
        {renderItemsWithLabelClass(
          assetHealthScore,
          "Asset Health Alert Score"
        )}
      </div>
      <div className={childClassName}>
        <span className="quater-update-heading">{assetScore}%</span>
        <span>{preventiveMaintenanceScore}</span>
        <span>{tpvScore}</span>
        <span>{incidentScore}</span>
        <span>{maintenanceWorkRequestScore}</span>
      </div>
    </div>
  );
};

export const PreventiveMaintenanceChildComponent = ({
  quarterMonths,
  pmpOpenCount,
  pmpCloseCount,
  pmpYear,
  pmpYtdTotal,
}) => {
  const calculatePercentage = (openCount, closeCount) => {
    return openCount !== 0 && closeCount !== 0
      ? ((closeCount / (openCount + closeCount)) * 100).toFixed(2) + "%"
      : "0.00%";
  };

  return (
    <>
      <div className="showcard-card-class-main-div">
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(
              preventiveMetaDataFirst,
              "Quater Update"
            )}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span className="quater-update-heading preventive-quarter-month">
              {quarterMonths}
            </span>
            <span>{pmpOpenCount}</span>
            <span>{pmpCloseCount}</span>
            <span>{calculatePercentage(pmpOpenCount, pmpCloseCount)}</span>
          </div>
        </div>
        <Divider />
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(preventiveMetaDataSecond, "Total YTD")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span className="quater-update-heading">{pmpYear}</span>
            <span>100%</span>
            <span>{pmpYtdTotal}%</span>
          </div>
        </div>
      </div>
    </>
  );
};
export const IncidentChildComponent = ({
  currentYear,
  inncidentTotalOpenNcCount,
  incidentTotalCloseNcCount,
  incidentTotalCount,
}) => {
  return (
    <>
      <div className="prevent-maintenance-showcard-div">
        <div className="prevent-maintenance-showcard-child-div">
          {renderItemsWithLabelClass(incidentMetaDataFirst, "Total YTD")}
        </div>
        <div className="prevent-maintenance-showcard-child-div">
          <span className="quater-update-heading">{currentYear}</span>
          <span>{inncidentTotalOpenNcCount}</span>
          <span>{incidentTotalCloseNcCount}</span>
          <span>
            {incidentTotalCount !== 0
              ? (
                  (incidentTotalCloseNcCount / incidentTotalCount) *
                  100
                ).toFixed(2) + "%"
              : "0.00%"}
          </span>
        </div>
      </div>
    </>
  );
};

export const TpvChildComponent = ({
  currentYear,
  tpvTotalCount,
  totalHighCount,
  totalHighCloseCount,
  tpvTotalCloseNcCount,
}) => {
  return (
    <>
      <div className="showcard-card-class-main-div">
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(tpvMetaDataFirst, "Total YTD")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span className="quater-update-heading">{currentYear}</span>
            <span>{tpvTotalCount}</span>
          </div>
        </div>
        <Divider />
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(tpvMetaDataSecond, "Closure Percentage")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span>{totalHighCount}</span>
            <span>{totalHighCloseCount}</span>
            <span>
              {totalHighCount !== 0
                ? ((totalHighCloseCount / totalHighCount) * 100).toFixed(2) +
                  "%"
                : "0.00%"}
            </span>
          </div>
        </div>
        <Divider />
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(tpvMetaDataThird, "Closure Percentage")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span>{tpvTotalCount}</span>
            <span>{tpvTotalCloseNcCount}</span>
            <span>
              {tpvTotalCount !== 0
                ? ((tpvTotalCloseNcCount / tpvTotalCount) * 100).toFixed(2) +
                  "%"
                : "0.00%"}
            </span>
          </div>
        </div>
        <Divider />
      </div>
    </>
  );
};
export const WorkRequestChildComponent = ({
  workRequestMonth,
  openData,
  closeData,
  currentYear,
  requestYdtTotal,
}) => {
  return (
    <>
      <div className="showcard-card-class-main-div">
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(workRequestMetaDataFirst, "Month")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span className="quater-update-heading">{workRequestMonth}</span>
            <span>{openData}</span>
            <span>{closeData}</span>
            <span>
              {openData !== 0 && closeData !== 0
                ? ((closeData / (openData + closeData)) * 100).toFixed(2) + "%"
                : "0.00%"}
            </span>
          </div>
        </div>
        <Divider />
        <div className="prevent-maintenance-showcard-div">
          <div className="prevent-maintenance-showcard-child-div">
            {renderItemsWithLabelClass(workRequestMetaData, "Total YTD")}
          </div>
          <div className="prevent-maintenance-showcard-child-div">
            <span className="quater-update-heading">{currentYear}</span>
            <span>100%</span>
            <span>{requestYdtTotal}%</span>
          </div>
        </div>
      </div>
    </>
  );
};
